import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import moment from "moment";
import { dateForListWithHours } from "../../../../constants/dataFormat";
import { FaCheck, FaClosedCaptioning, FaExclamation, FaTimes } from "react-icons/fa";
import { customColors } from "../../../../atoms/customColors";
import { useSetRecoilState, useRecoilState } from "recoil";

interface StatusTypes {
  [chave: string]: JSX.Element;
}

export default function ModalTransferDetail({ isOpen, setIsOpen, item }: any) {
  const finalRef = React.useRef(null);
  const colors = useRecoilState(customColors)[0];

  const statusTypes: StatusTypes = {
    "Efetivado": <FaCheck />,
    "Processando": <FaExclamation />,
    "Pendente": <FaExclamation />,
    "Remessa Gerada": <FaExclamation />,
    "Não efetivado": <FaExclamation />,
    "Cancelado": <FaTimes />,
  }

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"5xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>
                Detalhes da Solicitação de Transferência
              </Text>
            </Flex>
          </ModalHeader>
          {item && (
            <ModalBody>
              <Flex
                w={"100%"}
                alignItems={"flex-start"}
                minHeight={"250px"}
                height={"fit-content"}
                border={"2px solid #c4c4c4"}
                justifyContent={"space-evenly"}
                shadow={"md"}
                borderRadius={"6px"}
              >
                <TableContainer w={"100%"}>
                  <Table variant={"striped"} w={"100%"}>
                    <Thead>
                      <Tr>
                        <Th bgColor={colors.VARIANT} color={colors.WHITE}>
                          Data
                        </Th>
                        <Th bgColor={colors.VARIANT} color={colors.WHITE}>
                          Status
                        </Th>
                        <Th bgColor={colors.VARIANT} color={colors.WHITE}>
                          Observação
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {item.map((i: any) => {
                        return (
                          <Tr key={i.id}>
                            <Td fontSize={"14px"}>
                              {moment(i.criadoEm ? i.criadoEm : null).format(
                                dateForListWithHours
                              )}
                            </Td>
                            <Td fontSize={"14px"}>
                              {i.status ? 
                                (
                                  statusTypes.hasOwnProperty(i.status.status) ? 
                                    <Flex alignItems={"center"} justifyContent="flex-start">
                                      {statusTypes[i.status.status]} 
                                      <Flex ml={4}>{i.status.status}</Flex>
                                    </Flex>
                                    : 
                                    i.status.status
                                ) 
                                : 
                                ""
                              }
                            </Td>
                            <Td fontSize={"14px"}>
                              {i.observacao ? i.observacao : null}
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Flex>
            </ModalBody>
          )}
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={colors.GRAY} color={"white"} mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
